let option = {
    grid:{
        left:40,
        right:40,
        bottom:20,
        top:10
    },
    tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket, callback) {
           var param=params[0];
           var x=param.axisValue;
           var y=param.value;
           return '高程:'+y+'米<br />'+'距离:'+x
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value',
        boundaryGap: [0, '100%']
    },
    // dataZoom: [
    //     {
    //         type: 'inside',
    //         start: 0,
    //         end: 10
    //     },
    //     {
    //         start: 0,
    //         end: 10
    //     }
    // ],
    series: [
        {
            type: 'line',
            name: '高程',
            itemStyle: {
                color: 'rgb(255, 70, 131)'
            },
            data: []
        }
    ]
};

export default option;